(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ajax;

function ajax(_ref) {
  var data = _ref.data,
      url = _ref.url,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'GET' : _ref$type,
      _success = _ref.success,
      _error = _ref.error,
      headers = _ref.headers,
      xhrFields = _ref.xhrFields;
  var requestData = data;

  if (requestData && type === 'POST') {
    requestData = JSON.stringify(requestData);
  }

  $.ajax({
    data: requestData,
    url: url,
    headers: headers,
    xhrFields: xhrFields,
    type: type,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    success: function success(e) {
      _success && _success(e);
    },
    error: function error(e) {
      _error && _error(e);
    }
  });
}

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLanguage = getLanguage;
exports.setLanguage = setLanguage;
exports.urlFormat = urlFormat;
exports.jumpPage = jumpPage;
exports.isMobileDevice = isMobileDevice;
exports.changeIdSelectorToClassSelector = changeIdSelectorToClassSelector;
exports.parseUrl = parseUrl;
exports.formatDate = formatDate;
exports.formatInterDate = formatInterDate;
exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.deleteCookie = deleteCookie;
exports.checkCookie = checkCookie;
exports.setCookieWithExpiration = setCookieWithExpiration;
exports.debounceWrapper = debounceWrapper;
exports.throttle = throttle;
exports.prefexZone = prefexZone;
exports.showMask = showMask;
exports.hideMask = hideMask;
exports.hidePopOver = hidePopOver;
exports.showPopOver = showPopOver;
exports.handleWinScroll = handleWinScroll;
exports.initFaceBook = initFaceBook;
exports.getPointsSuccessTip = getPointsSuccessTip;
exports.scrollTo = scrollTo;
exports.getSecDomainName = getSecDomainName;
exports.numberFormat = numberFormat;
exports.toogleNavbar = toogleNavbar;
exports.timeFormat = timeFormat;
exports.scrollText = scrollText;
exports.getCountryFile = getCountryFile;
exports.getBuryingPointInfo = getBuryingPointInfo;

var _toastModal = _interopRequireDefault(require("../../components/toastModal"));

var _ajax = _interopRequireDefault(require("./ajax"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollTop; // 监听win top变化

var timer; // 获取语言

function getLanguage() {
  // return $('html')[0].lang ? $('html')[0].lang.toLowerCase() : 'en_us';
  var language = localStorage.getItem('ah-language') || 'en';
  return language;
} //  设置语言


function setLanguage() {
  var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
  localStorage.setItem('ah-language', lang);
} // url格式化


function urlFormat(url) {
  var spaceReg = /\s+/g; // 空格转'-'处理

  var formatReg = /\?+|\/+|#+|%+|\[+|\]+/g; // 特殊字符处理：？、/、#、%

  var repeatSpace = /-+/g; // 多个'-'处理成一个'-'

  return url.replace(spaceReg, '-').replace(formatReg, '').replace(repeatSpace, '-');
} // 跳转页面


function jumpPage(page, openWindow) {
  var href = page;

  if (openWindow) {
    window.open(href);
  } else {
    window.location.href = href;
  }
} // 判断移动or桌面设备


function isMobileDevice() {
  var reg = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;

  if (navigator.userAgent.match(reg)) {
    return true;
  }

  return false;
} // 转换ID选择器为类选择器


function changeIdSelectorToClassSelector(idSelector) {
  return idSelector ? ".".concat(idSelector.substr(1)) : '';
} // 获取url参数


function parseUrl(url) {
  // eslint-disable-next-line
  var pattern = /(\w+)=([\w%\.@-]+)/ig;
  var parames = {}; // eslint-disable-next-line
  // url = decodeURIComponent(url);

  url.replace(pattern, function (a, b, c) {
    parames[b] = c;
  });
  return parames;
}

function formatDate(date) {
  var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  // 非日期格式，进行字符串处理
  if (Object.prototype.toString.call(date) !== '[object Date]') {
    // eslint-disable-next-line no-param-reassign
    date = date.replace(/-/g, '/');
  }

  var dat = new Date(date);
  var curYear = dat.getFullYear();
  var curMonth = dat.getMonth() + 1 >= 10 ? dat.getMonth() + 1 : "0".concat(dat.getMonth() + 1);
  var curDate = dat.getDate() >= 10 ? dat.getDate() : "0".concat(dat.getDate());
  var curHours = dat.getHours() >= 10 ? dat.getHours() : "0".concat(dat.getHours());
  var curMinute = dat.getMinutes() >= 10 ? dat.getMinutes() : "0".concat(dat.getMinutes());
  var curSecond = dat.getSeconds() >= 10 ? dat.getSeconds() : "0".concat(dat.getSeconds());
  var res = '';

  switch (tag) {
    case 'minute':
      res = "".concat(curYear, "-").concat(curMonth, "-").concat(curDate, " ").concat(curHours, ":").concat(curMinute);
      break;

    case 'second':
      res = "".concat(curYear, "-").concat(curMonth, "-").concat(curDate, " ").concat(curHours, ":").concat(curMinute, ":").concat(curSecond);
      break;

    default:
      res = "".concat(curYear, "-").concat(curMonth, "-").concat(curDate);
  }

  return res;
}
/**
 * 国际日期显示格式
 * @param date 时间字符串
 * @param tag 显示到时分秒还是月
 * @returns {string}
 */


function formatInterDate(date) {
  var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (Object.prototype.toString.call(date) !== '[object Date]') {
    // eslint-disable-next-line no-param-reassign
    date = date.replace(/-/g, '/');
  }

  var monArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var dat = new Date(date);
  var flag = 'am';
  var curYear = dat.getFullYear();
  var curMonth = monArr[dat.getMonth()];
  var curDate = dat.getDate() >= 10 ? dat.getDate() : "0".concat(dat.getDate());
  var curHours = dat.getHours();

  if (curHours > 12) {
    // eslint-disable-next-line
    curHours = curHours - 12;
    flag = 'pm';
  }

  var curMinute = dat.getMinutes() >= 10 ? dat.getMinutes() : "0".concat(dat.getMinutes());
  var curSecond = dat.getSeconds() >= 10 ? dat.getSeconds() : "0".concat(dat.getSeconds());
  var res = '';

  switch (tag) {
    case 'minute':
      res = "".concat(curMonth, " ").concat(curDate, ", ").concat(curYear, " ").concat(curHours, ":").concat(curMinute, " ").concat(flag);
      break;

    case 'second':
      res = "".concat(curMonth, " ").concat(curDate, ", ").concat(curYear, " ").concat(curHours, ":").concat(curMinute, ":").concat(curSecond, " ").concat(flag);
      break;

    default:
      res = "".concat(curMonth, " ").concat(curDate, ", ").concat(curYear);
  }

  return res;
}
/**
* @method 获取Cookie
* @param  {String} key
* @return {String}
*/


function getCookie(key) {
  var cookies = document.cookie.split(';');
  key = key + '='; //如果刚好key前面一部分是相同的，则可能获取到不是自己当前key的值，所以加上=

  for (var i = 0; i < cookies.length; i += 1) {
    var cookie = cookies[i];

    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }

    if (cookie.indexOf(key) !== -1) {
      return cookie.substring(key.length, cookie.length);
    }
  }

  return '';
}
/**
* @method 设置Cookie
* @param  {String} key
* @return {String}
*/


function setCookie(key, value) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';
  var cookieDomain = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.aihouse.com';

  if (key && value.toString()) {
    document.cookie = "".concat(key, "=").concat(value, ";path=").concat(path, ";domain=").concat(cookieDomain, ";Max-Age=157680000");
  } else {
    console.error('set cookie need key and value!');
  }
}
/**
* @method 删除Cookie
* @param  {String} key
* @return {String}
*/


function deleteCookie(key) {
  var cookieDomain = '.aihouse.com';

  if (key) {
    var exp = new Date();
    exp.setTime(exp.getTime() + -1 * 24 * 60 * 60 * 1000);
    document.cookie = "".concat(key, "=;path=/;domain=").concat(cookieDomain, ";expires=").concat(exp);
  } else {
    console.error('set cookie need key!');
  }
}
/**
* @method 检查Cookie是否存在
* @param  {String} key
* @return {Boolean}
*/


function checkCookie(key) {
  return !!getCookie(key);
}
/**
* @method 设置cookie,指定过期时间
* @param  {String} key
* @return {Boolean}
*/


function setCookieWithExpiration(key, value, exp) {
  var cookieDomain = '.aihouse.com'; // 创建一个Date对象，表示当前日期和时间  

  var currentDate = new Date(); // 设置时间为当天的23:59:59 UTC时间  

  currentDate.setUTCHours(23, 59, 59, 0); // 将日期对象转换为UTC格式的字符串（以秒为单位）  

  var utcString = currentDate.toUTCString(); // 设置cookie  

  document.cookie = "".concat(key, "=").concat(value, ";path=/;domain=").concat(cookieDomain, ";expires=").concat(exp ? exp : utcString);
}
/**
* @method 函数防抖
* @param  {Function, Number|String}
* @return {Function}
*/


function debounceWrapper(fn) {
  var debounceTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  // eslint-disable-next-line
  var timer;
  return function () {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(function () {
      fn();
      timer = null;
    }, debounceTime);
  };
}
/**
 * @method 函数节流
 * @param {Function, Number|String}
 * @return {Function}
*/
// 简单的节流函数


function throttle(func, wait, mustRun) {
  var timeout;
  var startTime = new Date();
  return function () {
    var context = this; // eslint-disable-next-line prefer-rest-params

    var args = arguments;
    var curTime = new Date();
    clearTimeout(timeout); // 如果达到了规定的触发时间间隔，触发 handler

    if (curTime - startTime >= mustRun) {
      func.apply(context, args);
      startTime = curTime; // 没达到触发间隔，重新设定定时器
    } else {
      timeout = setTimeout(func, wait);
    }
  };
}
/**
* @method 位数补0
* @param  {Number, Number}
* @return {Number}
*/


function prefexZone(num, n) {
  return (Array(n).join(0) + num).slice(-n);
}
/**
* @method 生成模态框
* @param  {String, Bollean, Function}
*/


function showMask(option, callback) {
  var _option$color = option.color,
      color = _option$color === void 0 ? 'transparent' : _option$color,
      _option$zIndex = option.zIndex,
      zIndex = _option$zIndex === void 0 ? 1031 : _option$zIndex,
      _option$maskClick = option.maskClick,
      maskClick = _option$maskClick === void 0 ? true : _option$maskClick,
      _option$el = option.el,
      el = _option$el === void 0 ? '.base-layout' : _option$el,
      _option$fixed = option.fixed,
      fixed = _option$fixed === void 0 ? false : _option$fixed;
  scrollTop = $('html').scrollTop();
  $(el).prepend("<div class=\"ahm-modal-mask\" style=\"background-color: ".concat(color, "; z-index: ").concat(zIndex, "\"></div>"));

  if (fixed) {
    $('body').css({
      overflow: 'hidden',
      position: 'fixed',
      top: $('html').scrollTop() * -1
    });
  }

  if (maskClick) {
    $(el).on('click', '.ahm-modal-mask', function () {
      $(this).remove();

      if (fixed) {
        $('body').css({
          overflow: 'auto',
          position: 'static',
          top: 'auto'
        });
        $('html').scrollTop(scrollTop);
      } // eslint-disable-next-line no-unused-expressions


      callback && callback();
    });
  }
}
/**
* @method 取消模态框
* @param  {Boolean}
*/


function hideMask() {
  var isFixed = $('.base-layout').css('position');

  if (isFixed === 'fixed') {
    $('body').css({
      overflow: 'auto',
      position: 'static',
      top: 'auto'
    });
    $('html').scrollTop(scrollTop);
  }

  $('.ahm-modal-mask').remove();
}
/**
 * @method 取消气泡框
 * @param {el, Height}
 */


function hidePopOver(el) {
  $(el).find('.ahm-popOver__content').css({
    height: 0
  });
  setTimeout(function () {
    $(el).find('.ahm-popOver').removeClass('show');
  }, 240);
}
/**
 * @method 生成气泡框
 * @param {el, Height}
 */


function showPopOver(el, height) {
  $(el).find('.ahm-popOver').addClass('show');
  $(el).find('.ahm-popOver__content').css({
    height: height
  });
  showMask({
    el: el
  }, function () {
    hidePopOver(el);
  });
}
/**
 * @method 监听window滚动
 * @param {el, callback}
 */


function handleWinScroll(el, callback) {
  $(window).scroll(function () {
    var screenHeight = $(window).height();
    var winScrollTop = $(document).scrollTop();

    if ($(el).length > 0) {
      var offsetTop = $(el).offset().top;

      if (winScrollTop + screenHeight > offsetTop) {
        // eslint-disable-next-line no-unused-expressions
        callback && callback();
      }
    }
  });
}
/**
 * @method 初始化facebook
 * @param {el, callback}
 */


function initFaceBook() {
  console.log('initFacebook'); // facebook登录初始化

  window.fbAsyncInit = function () {
    var facebookClientId = $('#facebookClientId').val();
    FB.init({
      appId: facebookClientId,
      cookie: true,
      // enable cookies to allow the server to access
      xfbml: true,
      // parse social plugins on this page
      version: 'v3.2'
    });
  };

  (function (d, s, id) {
    var js;
    var fjs = d.getElementsByTagName(s)[0];

    if (d.getElementById(id)) {
      return;
    } // eslint-disable-next-line prefer-const


    js = d.createElement(s);
    js.id = id;
    js.src = '//connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
}
/**
 * 获取积分成功提示
 * @param num task 任务名称
 */


function getPointsSuccessTip(num, task) {
  (0, _toastModal.default)({
    iconClass: 'icon-chenggong',
    content: "".concat($.i18n.prop('integral.success.tip1'), " ").concat(num, " ").concat($.i18n.prop('integral.success.tip2'), " ").concat(task, "!")
  });
}
/**
 * @method 页面滚动到指定元素
 * @param {el, callback}
 */


function scrollTo(dom) {
  var topHeight = $('.base-header__country').height() + $('.base-header__nav').height();
  var scrollTops = $(dom).offset().top - topHeight;
  $('html,body').animate({
    scrollTop: scrollTops
  }, 1000);
}
/**
 * @method 获取二级域名
 * @param {url: String}
 */


function getSecDomainName(url) {
  return url.split('.')[0].split('//')[1];
}
/**
 * 整数逢三断一
 * @param value
 */


function numberFormat(value) {
  if (!value) {
    return '0';
  }

  var result = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 将整数部分逢三一断

  return result;
}
/**
 * @method 导航栏切换（品牌馆）
 * @param {el}
* */


function toogleNavbar() {
  $(window).scroll(function () {
    clearTimeout(timer);

    if ($(document).scrollTop() > 100) {
      $('#navbarContent').addClass('rollUp');
      $('#navbarBrand').removeClass('rollUp');
      timer = setTimeout(function () {
        $('.navbarBrand-wpt').addClass('visible');
      }, 200);
    } else {
      $('#navbarContent').removeClass('rollUp');
      $('#navbarBrand').addClass('rollUp');
      $('.navbarBrand-wpt').removeClass('visible');
    }
  });
}
/**
 * 时间展示（00''00'）
 * @param value
 */


function timeFormat(value) {
  var val = Number(value);
  var hourText = '';

  if (val > 60) {
    var min = parseInt(val / 60, 0);
    var minutes = prefexZone(min, min.length);
    var seconds = prefexZone(val % 60, 2);
    hourText = "".concat(minutes, ":").concat(seconds);
  } else {
    hourText = "00:".concat(val);
  }

  return hourText;
}
/**
 * marquee效果
 * @return void
 */


function scrollText(ID) {
  var scrollingDiv = document.getElementById(ID);
  scrollingDiv.innerHTML += scrollingDiv.innerHTML; // 函数实现无缝滚动效果

  function startScroll() {
    scrollingDiv.style.transform = "translateX(0)";
    scrollingDiv.style.animationPlayState = "running";
  }

  function stopScroll() {
    scrollingDiv.style.animationPlayState = "paused";
  }

  scrollingDiv.addEventListener("mouseenter", stopScroll);
  scrollingDiv.addEventListener("mouseleave", startScroll);
  startScroll();
}
/**
 * 请求国家文件
 * @return void
 */


function getCountryFile(cb) {
  (0, _ajax.default)({
    url: 'https://ai-study1.oss-cn-shenzhen.aliyuncs.com/prod/static/common/country.json',
    type: 'GET',
    success: function success(res) {
      cb && cb(res);
    }
  });
} //获取埋点相关基础数据


function getBuryingPointInfo() {
  var userInfo = {};
  var emailObj = $("#userInfo_email");

  if (emailObj != null && emailObj.val() !== undefined && emailObj.val() !== '') {
    userInfo.account = emailObj.val();
  } else {
    userInfo.account = "";
  }

  var userIdObj = $("#userInfo_userId");

  if (userIdObj != null && userIdObj.val() !== undefined && userIdObj.val() !== '') {
    userInfo.userId = userIdObj.val();
    userInfo.isLogin = 1;
  } else {
    userInfo.userId = "";
    userInfo.isLogin = 0;
  }

  userInfo.ip = $("#userip").val();
  var countryObj = $("#userInfo_country");

  if (countryObj != null && countryObj.val() !== undefined && countryObj.val() !== '') {
    userInfo.country = countryObj.val();
  } else {
    userInfo.country = "";
  }

  var organTypeObj = $("#userInfo_isFactory");

  if (organTypeObj != null && organTypeObj.val() !== undefined && organTypeObj.val() !== '') {
    userInfo.organType = organTypeObj.val() === "1" ? "企业" : "零售";
  } else {
    userInfo.organType = "";
  }

  var organIdObj = $("#userInfo_organId");

  if (organIdObj != null && organIdObj.val() !== undefined && organIdObj.val() !== '') {
    userInfo.organId = organIdObj.val();
  } else {
    userInfo.organId = "";
  }

  userInfo.pageUrl = window.location.href;
  userInfo.referrerUrl = document.referrer;
  userInfo.channelCode = getCookie("aihouse_channel_code");
  userInfo.hw_device = isMobileDevice() ? "mobile" : "PC";
  return userInfo;
}

},{"../../components/toastModal":5,"./ajax":1}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleSchemeLink = handleSchemeLink;

var _common = require("../../common/js/common");

// eslint-disable-next-line import/prefer-default-export
function handleSchemeLink() {
  $('.base-layout').on('click', '.js-scheme-item', function () {
    var parentDom = $(this).parents('.scheme-item');
    var name = parentDom.attr('data-schemeName');
    var schemeId = parentDom.attr('data-schemeId');
    var userId = parentDom.attr('data-userId');
    var url = "/scheme/".concat((0, _common.urlFormat)(name), "-").concat(schemeId, ".").concat(userId);

    if ((0, _common.isMobileDevice)()) {
      (0, _common.jumpPage)(url, false);
    } else {
      (0, _common.jumpPage)(url, true);
    }
  });
  $('.base-layout').on('click', '.js-homePage', function (e) {
    e.stopPropagation();
    var parentDom = $(this).parents('.scheme-item');
    var author = parentDom.attr('data-author');
    var userId = parentDom.attr('data-userId');
    var url = "/designGallery/mainPage/".concat((0, _common.urlFormat)(author), "-").concat(userId);

    if ((0, _common.isMobileDevice)()) {
      (0, _common.jumpPage)(url, false);
    } else {
      (0, _common.jumpPage)(url, true);
    }
  });
}

},{"../../common/js/common":2}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initPagination;

function initPagination(_ref, pageChange) {
  var totalCounts = _ref.totalCounts,
      pageSize = _ref.pageSize,
      pageIndex = _ref.pageIndex;
  var totalCountsNnum = Number(totalCounts);
  var pageSizeNnum = Number(pageSize);
  var pageIndexNum = Number(pageIndex);

  if (totalCounts === 0 && pageIndex === 1) {
    return;
  }

  $.jqPaginator('#pagination', {
    totalCounts: totalCountsNnum,
    pageSize: pageSizeNnum,
    currentPage: pageIndexNum,
    prev: "<li class='page-item'>\n            <a class='page-link' href='javascript:;' aria-label='Previous'>\n              <span aria-hidden='true'>\n                <i class='iconfont icon-zuojiantou'></i>\n              </span>\n            </a>\n          </li>",
    next: "<li class='page-item'>\n            <a class='page-link' href='javascript:;' aria-label='Next'>\n              <span aria-hidden='true'>\n                <i class='iconfont icon-youjiantou'></i>\n              </span>\n            </a>\n          </li>",
    page: "<li class='page-item'><a class='page-link' href='javascript:;'>{{page}}</a></li>",
    onPageChange: function onPageChange(page, type) {
      if (type === 'init') {
        return;
      }

      if (pageChange) {
        pageChange(page, type);
      }
    }
  });
}

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = showToastModal;

function showToastModal(_ref) {
  var iconClass = _ref.iconClass,
      content = _ref.content,
      description = _ref.description;
  $('#toastModal-content').text(content);
  $('#toastModal-icon').removeClass().addClass(iconClass).addClass('iconfont');

  if (description) {
    $('#toastModal').addClass('toast-modal--dec');
    $('#toastModal-desc').text(description).show();
  } else {
    $('#toastModal-desc').hide();
  }

  $('#toastModal').modal({
    show: true,
    backdrop: false
  }); // 自动关闭弹窗

  setTimeout(function () {
    $('#toastModal').modal('hide');
  }, 2000);
}

},{}],6:[function(require,module,exports){
"use strict";

var _common = require("../../common/js/common");

var _pagination = _interopRequireDefault(require("../../components/pagination"));

var _schemeItem = require("../../components/designgallery/schemeItem");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-restricted-syntax */
// import onFloatButtonClick from '../../components/floatButton';
var paramUrl = {}; // 拼接参数，跳转页面

function jointJump() {
  var url = '/designScheme/list?';

  for (var key in paramUrl) {
    if (paramUrl[key] !== '') {
      url += "".concat(key, "=").concat(paramUrl[key], "&"); // url += key + '=' + paramUrl[key] + '&';
    }
  }

  url = url.substr(0, url.length - 1);
  (0, _common.jumpPage)(url, false);
} // 监听筛选条件


function handleFilter() {
  $('.filter-item__bd').click(function () {
    var parent = $(this).parent();
    var isActive = parent.hasClass('active');
    var category = parent.find('.filter-item__categories');

    if (isActive) {
      category.height(0);
      parent.removeClass('active');
    } else {
      var height = category.data('height');
      category.height(height);
      parent.addClass('active');
    }
  });
  $('.categories__name').click(function () {
    var value = $(this).data('id');
    var key = $(this).parent().data('type');
    paramUrl[key] = value;
    paramUrl.pageIndex = ''; // 页码置空

    jointJump();
  });
  $('.hd-filter__link').click(function () {
    var id = $(this).data('id');
    paramUrl.sort = id;
    paramUrl.pageIndex = ''; // 页码置空

    jointJump();
  });
}
/*
  初始化展开筛选条件
  rt：空间、st：风格、ht：户型、a：面积、pageIndex：页码、pageSize：页容量
  sort: 2:最新； 1：最热
*/


function initFilter() {
  // 包含参数
  console.log(paramUrl.st, paramUrl.rt, paramUrl.ht, paramUrl.a);

  if (paramUrl.st || paramUrl.rt || paramUrl.ht || paramUrl.a || paramUrl.tp) {
    console.log('hav参数');
    $('.filter-item__categories').each(function (index, item) {
      var type = $(item).data('type');
      var height = $(item).data('height');

      if (paramUrl[type] !== '' && paramUrl[type] !== undefined) {
        $(item).height(height);
        $(item).find('.categories__name').each(function (inIndex, inItem) {
          var id = $(inItem).data('id');

          if (id === Number(paramUrl[type])) {
            $(inItem).addClass('active');
          }
        });
        $(item).parent().addClass('active');
      }
    });
  } else {
    console.log('不包含参数'); // 不包含
    // const parent = $('.filter-item').first();
    // const category = parent.find('.filter-item__categories');
    // const categoryHeight = category.data('height');
    // parent.addClass('active');
    // category.height(categoryHeight);
    // category.find('.categories__name').first().addClass('active');
  } // 判断最新，最热


  if (paramUrl.sort) {
    $('.hd-filter__link').each(function (index, item) {
      var id = $(item).data('id');

      if (Number(paramUrl.sort) === id) {
        $(item).addClass('active');
      }
    });
  } else {
    // 默认选择最新
    $('.hd-filter__link').first().addClass('active');
  }
} // 初始化,渲染分页组件


function renderPagination() {
  var totalCounts = Number($('.hd-result__total').text());
  var param = {
    totalCounts: totalCounts,
    pageSize: 15,
    pageIndex: paramUrl.pageIndex || 1
  };
  console.log(param);
  (0, _pagination.default)(param, function (index) {
    paramUrl.pageIndex = index;
    jointJump();
  });
} // 初始化滚动条


function initScroller() {
  $('.scheme-filter').mCustomScrollbar({
    autoHideScrollbar: false,
    theme: 'dark'
  });
}

$(function () {
  paramUrl = (0, _common.parseUrl)(window.location.href);
  initFilter();
  handleFilter();
  renderPagination(); // onFloatButtonClick();

  initScroller();
  (0, _schemeItem.handleSchemeLink)();
});

},{"../../common/js/common":2,"../../components/designgallery/schemeItem":3,"../../components/pagination":4}]},{},[6]);
